import { useContext } from 'react'
import styles from './AuthForm.module.scss'
import sharedStyles from '../../../sharedStyles.module.scss'
import { GlobalNotificationContext } from '../../../Context/GlobalNotification/GlobalNotificationProvider'
import { GlobalLoaderContext } from '../../../Context/GlobalLoader/GlobalLoader'
import { NotificationType } from '../../../Context/GlobalNotification/Types'
import { userAuthenticate } from '../../../service/User/api'
import { LoginPageType, LoginPageTypes } from '../LoginPageTypes'
import { RHFSimpleFormBuilder } from '../../../service/FormGenerator/RHFSimpleFormBuilder'
import { formsDefinitions } from '../../../service/FormGenerator/FormDefinitions'
import { Login } from '../../../service/FormGenerator/FormDefinitions/zodSchema/authSchema'

interface Props {
  changeFormHandler: (formType: LoginPageTypes) => void
}

export const AuthForm = ({ changeFormHandler }: Props): JSX.Element => {
  const showNotification = useContext(GlobalNotificationContext)
  const showLoader = useContext(GlobalLoaderContext)

  const onSubmit = async (credentials: Login) => {
    showLoader(true)
    try {
      await userAuthenticate({
        username: credentials.username.toLocaleLowerCase(),
        password: credentials.password
      })
      showNotification(NotificationType.INFO, 'Logowanie przebiegło pomyślnie')
    } catch (err) {
      showNotification(NotificationType.ERROR, 'Wprowadzono niepoprawne dane')
    }
    showLoader(false)
  }

  return (
    <section>
      <RHFSimpleFormBuilder
        formDefinition={formsDefinitions.auth}
        onSubmit={onSubmit}
      />

      <div className={styles.AdditionalInfoContainer}>
        <p>
          <span>Jeżeli nie masz jeszcze konta, </span>
          <button
            type='button'
            onClick={(): void => changeFormHandler(LoginPageType.SIGNUP)}
            className={sharedStyles.ButtonToInternalLink}
          >
            Zarejestruj się
          </button>
        </p>
        <p>
          <span>Nie pamiętasz hasła do swojego konta?</span>
          <button
            type='button'
            onClick={(): void => changeFormHandler(LoginPageType.RESTORE)}
            className={sharedStyles.ButtonToInternalLink}
          >
            {' Kliknij tutaj'}
          </button>
        </p>
      </div>
    </section>
  )
}
